import { render } from "./AddWithdrawAccount.vue?vue&type=template&id=4ceb4722&scoped=true"
import script from "./AddWithdrawAccount.vue?vue&type=script&lang=js"
export * from "./AddWithdrawAccount.vue?vue&type=script&lang=js"

import "./AddWithdrawAccount.vue?vue&type=style&index=0&id=4ceb4722&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ceb4722"]])

export default __exports__